<template>
  <div class="form-wrapper">
    <div class="input-group mb-3" :class="[fields.firstName.length > 0 ? (validate.firstName ? 'valid' : 'error') : '']">
      <input type="text" id="fname" v-model="fields.firstName" @change="component.validateHumanName">
      <label class="form-label" for="fname">
        <div class="text">First Name</div>
      </label>
    </div>
    <div class="input-group mb-3" :class="[fields.lastName.length > 0 ? (validate.lastName ? 'valid' : 'error') : '']">
      <input type="text" id="lname" v-model="fields.lastName" @change="component.validateHumanName">
      <label class="form-label" for="lname">
        <div class="text">Last Name</div>
      </label>
    </div>
    <div class="input-group mb-3" :class="[fields.email.length > 0 ? (validate.email ? 'valid' : 'error') : '']">
      <input id="bemail" type="email" @change="component.validateEmail" v-model.trim="fields.email">
      <label class="form-label" for="bemail">
        <div class="text">Business Email</div>
      </label>
    </div>
    <div class="input-group mb-3" :class="[fields.phone.length > 0 ? (validate.phone ? 'valid' : 'error') : '']">
      <input type="tel" id="phone" @input="component.maskPhone" v-model="fields.phone" @change="component.validatePhone">
      <label class="form-label" for="phone">
        <div class="text">Phone or Mobile</div>
      </label>
    </div>
  </div>
</template>
<script setup lang="ts">
import component from "./contact.component";
const { fields, validate } = component;
// defineEmits()
// import { MdField, MdInput } from "vue-material/dist/components"
// import 'vue-material/dist/vue-material.min.css'
// import 'vue-material/dist/theme/default.css'
</script>